import * as Yup from "yup";

export const branchValidationSchema = Yup.object({
  name: Yup.string().required("Nombre es requerido"),
  direccion: Yup.string(),
  estado: Yup.string(),
  pais: Yup.string(),
  latitude: Yup.string().matches(/^(\+|-)?(?:90(\.0{1,6})?|(?:[0-9]|[1-8][0-9])(\.[0-9]{1,6})?)$/,"Latitud incorrecta. Debe incluirse un número positivo o negativo con hasta 6 decimales"),
  longitude: Yup.string().matches(/^(\+|-)?(?:180(\.0{1,6})?|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)$/,"Longitud incorrecta. Debe incluirse un número positivo o negativo con hasta 6 decimales"),
  company: Yup.object({ id: Yup.string().required("Compañía es requerido") }),
});
